import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import values from 'ramda/src/values';

const CertificationLevels = ({ data }) => {
    const levels = isEmpty(data) ? [] : values(data);
    return (
        <div className="cert-levels h-100">
            <div className="header">
                <span className="dsl-b22 bold">Levels</span>
            </div>
            <div className="levels-header desktop-screen">
                <span className="d-flex-5 dsl-m12">Level</span>
                <span className="d-flex-2 dsl-m12 text-end">Started</span>
                <span className="d-flex-2 dsl-m12 text-end">Completed</span>
            </div>
            {levels.map((level, index) => {
                const completed = !isNil(level.completed_at);
                const started = !isNil(level.started_at);
                const dateStart = started ? moment.utc(level.started_at).local().format('MMM D, YY') : 'Not started';
                const compDate = completed ? moment.utc(level.completed_at).local().format('MMM D, YY') : 'Current';
                const completedDate = started ? compDate : '';
                return (
                    <div className="levels-item d-flex ssm-column" key={`cert-level-${index}`}>
                        <div className="d-flex d-flex-5 w-100">
                            <label className="dsl-b14 mobile-screen w-40">Level</label>
                            <span className={completed ? 'dsl-l16 line-through' : 'dsl-b16'}>{level.title || 'Jr Sales Consultant'}</span>
                        </div>
                        <span className={`d-flex-2 text-end ssm-left w-100 ${started && !completed ? 'dsl-b16' : 'dsl-l16'}`}>
                            <label className="dsl-b14 mobile-screen w-40">Started</label>
                            {dateStart}
                        </span>
                        <span className={`d-flex-2 text-end ssm-left w-100 ${started && !completed ? 'dsl-b16' : 'dsl-l16'}`}>
                            <label className="dsl-b14 mobile-screen w-40">Completed</label>
                            {completedDate}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

CertificationLevels.propTypes = {
    data: PropTypes.any,
};

CertificationLevels.defaultProps = {
    data: {},
};

export default memo(CertificationLevels);
